/* eslint-disable */
import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import 'contents/assets/scss/page/teacher.scss';
import Tab from '../../../component/Inc/Tab';
function TeacherCampaignCreate() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '1. 종합평가 부문', value: 0},
    {title: '2. 화상 종합평가 부문', value: 1},
    {title: '3. 개인 인센티브 부문', value: 2},
    {title: '4. 영역별 인센티브 배정 관리자 평가 부분', value: 3}
  ];
  return (
    <main className="com_container p_campaign">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu2_10">
            실적관리 캠페인<span className="bar"></span>
            <span className="point_txt">캠페인 만들기</span>
          </h2>
          <div className="com_btn_wrap">
            <Link to="/Teacher/Campaign/Create" className="com_btn orange s btn_plus">
              캠페인 만들기
            </Link>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <section className="com_board_form">
                <div className="form_item">
                  <strong className="form_tit">캠페인 기간 </strong>
                  <div className="date_wrap">
                    <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                    <span className="divider"> ~ </span>
                    <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  </div>
                </div>
                <span className="bar"></span>
                <div className="form_item">
                  <strong className="form_tit">캠페인 명</strong>
                  <input type="text" placeholder="캠페인 명 입력" className="input s type_search" />
                </div>
                <span className="bar"></span>
                <div className="form_item">
                  <strong className="form_tit">발표일</strong>
                  <div className="date_wrap">
                    <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  </div>
                </div>
                <span className="bar"></span>
                <div className="form_item">
                  <strong className="form_tit">시상계획일</strong>
                  <div className="date_wrap">
                    <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  </div>
                </div>
                <div className="com_btn_wrap">
                  <button className="btn_edit"></button>
                </div>
              </section>
            </div>
          </section>
          <section className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
          </section>

          <section className="box full">
            <div className="board_wrap_row">
              <section className="board_wrap">
                <div className="com_info center">
                  <p className="name">공지 내용 등록</p>
                </div>
                <div className="com_input_wrap">
                  <div className="editor light_gray">
                    에디터
                    <button className="com_btn gray xs">+ 이미지 등록</button>
                  </div>
                  <div className="com_input_upload">
                    <input type="file" className="input_file" />
                    <button className="btn_upload com_btn gray xs wl">파일 등록</button>
                    <p className="file">
                      <span className="txt">File name.pdf</span>
                      <button type="button" className="btn_del_file"></button>
                    </p>
                  </div>
                </div>
                <hr className="com_divider" />
              </section>
              <section className="board_wrap">
                <div className="com_info center">
                  <p className="name">각 내용 상세 값 등록</p>
                </div>
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="22%" />
                    <col width="73%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th colSpan={2} className="th_center">
                        국어
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>목표 포인트</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="text" className="input" value="" />
                          <span className="txt">이상</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>목표 타임</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="text" className="input" value="" />
                          <span className="txt">이상</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>교사 추가</th>
                      <td>
                        <section className="com_board_search">
                          <article className="search">
                            <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                            <button className="com_btn gray ws s icon_search"></button>
                          </article>
                        </section>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="detail_tit dot">
                  포함된 교사 <span className="sub"> ( * 선택한 교사가 대표교사가 됩니다.)</span>
                </div>
                <ul className="teach_edit_list">
                  <li className="item">
                    홍길동 <button type="button" className="btn_del_file"></button>
                  </li>
                  <li className="item">
                    홍길동 <button type="button" className="btn_del_file"></button>
                  </li>
                  <li className="item">
                    홍길동 <button type="button" className="btn_del_file"></button>
                  </li>
                </ul>
                <div className="detail_tit dot">순위별 시상 금액</div>
                <table className="com_board_list">
                  <colgroup>
                    <col width="auto" />
                    <col width="27%" />
                    <col width="27%" />
                    <col width="27%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th className="th_center">그룹</th>
                      <th className="th_center">포인트 점수</th>
                      <th className="th_center">시상금액</th>
                      <th className="th_center">인원</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div className="com_input_wrap count">
                          <button className="btn btn_minus_gray"></button> 1위
                        </div>
                      </td>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="text" className="input full" value="" />
                          <span className="txt">이상</span>
                        </div>
                      </td>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="text" className="input full" value="" />
                          <span className="txt">원</span>
                        </div>
                      </td>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="text" className="input full" value="" />
                          <span className="txt">명</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="com_input_wrap count">
                          <button className="btn btn_minus_gray"></button> 2위
                        </div>
                      </td>
                      <td>96p 이상</td>
                      <td>850,000</td>
                      <td>2</td>
                    </tr>
                  </tbody>
                </table>
                <div className="com_btn_wrap right">
                  <button className="com_btn gray xs">+추가</button>
                </div>
                <div className="detail_tit dot">순위별 시상 금액</div>
                <table className="com_board_list">
                  <colgroup>
                    <col width="auto" />
                    <col width="27%" />
                    <col width="27%" />
                    <col width="27%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th className="th_center">그룹</th>
                      <th className="th_center">포인트 점수</th>
                      <th className="th_center">시상금액</th>
                      <th className="th_center">인원</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div className="com_input_wrap count">
                          <button className="btn btn_minus_gray"></button> 1위
                        </div>
                      </td>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="text" className="input full" value="" />
                          <span className="txt">이상</span>
                        </div>
                      </td>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="text" className="input full" value="" />
                          <span className="txt">원</span>
                        </div>
                      </td>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="text" className="input full" value="" />
                          <span className="txt">명</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="com_input_wrap count">
                          <button className="btn btn_minus_gray"></button> 2위
                        </div>
                      </td>
                      <td>96p 이상</td>
                      <td>850,000</td>
                      <td>2</td>
                    </tr>
                  </tbody>
                </table>
                <div className="com_btn_wrap right">
                  <button className="com_btn gray xs">+추가</button>
                </div>
              </section>
            </div>
            <hr className="com_divider" />
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">저장</button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}

export default TeacherCampaignCreate;
